import React, {useEffect, useState} from 'react';
import HeaderNav from "./_common/HeaderNav";
import {useHistory} from "react-router-dom";
import LoaderSpinner from "./_common/Loader";
import CreditItem from "./credits/CreditItem";
import layerSwitcherIcon from '../assets/images/mapbox_controls/layer-switcher.png';

const About = () => {
    const history = useHistory();
    const [progress, setProgress] = useState(false)

    useEffect(() => {
        try {
            setProgress(true);
            const timeout = setTimeout(() => {
                (async () => setProgress(false))();
            }, 500);
            return () => {
                clearTimeout(timeout);
            };
        } catch (e) {
            setProgress(false);
        }
    }, []);

    return (
        <div className="container-fluid" id={'container-heading'}>
            <HeaderNav
                title={`A Propos`}
                backToDo={() => history.push('/')}
                searchAction={false}
            />
            <div className={`container-data ${progress && 'loader'}`} id={'faq-list'}>
                {
                    progress ?
                        <LoaderSpinner/>
                        :
                        <>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        A quoi sert cette application ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Colzones est une application Colas destinée aux personnels de chantier. Elle
                                            permet une visualisation simple et rapide des différentes zones du chantier,
                                            depuis un smartphone ou une tablette.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        Comment utiliser Colzones ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            <i className="fa fa-home icon-color"/> : Permet de revenir à l'écran
                                            d'accueil. Dans
                                            cet écran, un
                                            menu permet de sélectionner votre agence, puis un deuxième menu permet de
                                            sélectionner le chantier souhaité.
                                        </p>
                                        <p>
                                            Pour revenir au menu précédent, cliquer sur l'icône <i
                                            className="fas fa-chevron-left icon-color"/> en haut à
                                            gauche.
                                        </p>
                                        <p>
                                            Dans la liste de chantiers, il est possible d'effectuer une recherche par
                                            nom ou par référence en cliquant sur l'icône <i
                                            className="fas fa-search icon-color"/>.
                                        </p>
                                        <p>
                                            Une fois le chantier sélectionné, on bascule sur l'écran cartographique.
                                        </p>
                                        <p>
                                            <i className="fa fa-map icon-color"/> : Permet d'accéder à l'écran
                                            cartographique. Cet
                                            écran présente toujours le dernier chantier que vous avez sélectionné. Il
                                            permet la géolocalisation de l'utilisateur, l'indication des zones du
                                            chantier ainsi qu’une alerte en cas d'entrée dans une zone non autorisée.
                                        </p>
                                        <p>
                                            Pour revenir à la liste de chantiers disponibles, cliquer sur l'icône <i
                                            className="fas fa-chevron-left icon-color"/> en haut à gauche.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        Comment fonctionne l'écran cartographique ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Afin de faciliter la prise en main, cet écran se présente comme une
                                            application de géolocalisation classique, type Google Maps..
                                        </p>
                                        <p>
                                            Il est possible de déplacer la carte à l'aide d'un doigt. Il est également
                                            possible de zoomer et effectuer une rotation de la carte à l'aide de 2
                                            doigts.
                                        </p>
                                        <p>
                                            On retrouve les boutons de zoom +/-, un bouton pour réorienter la carte, et
                                            un bouton pour recentrer la carte sur votre position.
                                        </p>
                                        <p>
                                            Un bouton supplémentaire a été ajouté
                                            <img src={layerSwitcherIcon} alt={'icone gestion affichage'}/> afin
                                            de sélectionner
                                            les zones que vous souhaitez afficher ou masquer. Cela permet d'améliorer la
                                            lisibilité de la carte.
                                        </p>
                                        <p>
                                            Vous pouvez cliquer sur chacune des zones afin d'afficher une courte
                                            description. Pour faire disparaître la fenêtre de description, cliquez
                                            ailleurs sur l'écran.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        A quoi correspondent les zones affichées ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Les zones non autorisées apparaissent en rouge. Elles sont toujours
                                            présentes sur la carte, on ne peut pas les masquer. Lorsque vous entrez dans
                                            une zone rouge, une alerte apparaît à l'écran. L’alerte disparaît
                                            automatiquement, ou bien en cliquant n’importe où sur
                                            l’écran.
                                        </p>
                                        <p>
                                            Les zones danger apparaissent en jaune. Ce sont des zones "tampons" à
                                            proximité immédiate des zones interdites. Vous pouvez les masquer en
                                            décochant la case correspondante.

                                        </p>
                                        <p>
                                            Les zones neutres apparaissent en gris. Elles apparaissent à titre
                                            informatif. Vous pouvez les masquer en décochant la case correspondante.
                                        </p>
                                        <p>
                                            Les zones autorisées apparaissent en vert. Elles indiquent des zones où la
                                            circulation sur le chantier est libre. Vous pouvez les masquer en décochant
                                            la case correspondante.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        Mon chantier n'apparaît pas dans l'application, que faire ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Cela signifie que le chantier n'a pas encore été ajouté à la base de
                                            données. Contactez votre référent Colzones au sein de l'agence.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        Je n'arrive pas à voir ma position dans l'application ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Vérifiez que la localisation est bien activée dans les paramètres du
                                            téléphone, pour que l'application puisse accéder à votre position.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={'row w-100 m-0'}>
                                <div className={`card card-no-cursor`}>
                                    <div className="card-title">
                                        La carte ne se met pas à jour ou bien je vois un écran noir ?
                                    </div>
                                    <div className="card-body-bordered faq-item">
                                        <p>
                                            Vérifiez votre connexion réseau. L'application nécessite un bon signal 3G
                                            (ou mieux) pour fonctionner correctement.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/*Credit Item Card*/}
                            <div className={'row w-100 m-0'} key={'credits'}>
                                <CreditItem/>
                            </div>
                        </>
                }
            </div>
        </div>
    );
};

export default About;
